/**
 * Utility functions for hexadecimal encoding and decoding.
 */

/**
 * Decodes a hex string into a Uint8Array.
 * @param hexString - The input hexadecimal string.
 * @returns The decoded Uint8Array.
 */
export function decodeHex(hexString: string): Uint8Array {
  const matches = hexString.match(/[a-fA-F0-9]{2}/g)
  if (!matches) return new Uint8Array()
  return new Uint8Array(matches.map((byte) => parseInt(byte, 16)))
}

/**
 * Encodes a Uint8Array into a hexadecimal string.
 * @param input - The input Uint8Array.
 * @returns The hex encoded string.
 */
export function encodeHex(input: Uint8Array): string {
  return Array.from(input)
    .map((value) => ('0' + value.toString(16)).slice(-2))
    .join('')
}

/**
 * Encodes a string into hex by converting it to UTF-8 first.
 * @param input - The input string.
 * @returns The hex encoded string.
 */
export function encodeString(input: string): string {
  const encoder = new TextEncoder()
  return encodeHex(encoder.encode(input))
}
